module.exports = __webpack_public_path__ + "img/thunderstorm.b3660bf9.jpg";